import React from 'react';
import { Container, Col } from 'react-bootstrap';
import TopNavBar from '../Components/TopNavBar';
import ContentBlock from '../Components/ContentBlock';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';
import Renginys from '../Components/Renginys';
import RenginiaiService from '../Api/RenginiaiService';

class RenginiaiPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageName: 'Renginiai',
            renginiaList : []
        }
    }

    componentDidMount() {
        RenginiaiService.getRenginiai().then((response) => {
            this.setState({ renginiaList: response.data });
        });
    }

    render() {

        const pageStyle = {
            backgroundImage: "url(renginiai-page-background.jpg)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        return (
            <Container fluid style={pageStyle}>
                <TopNavBar activeRoute={1} />
                <Container>
                    <h1 className='page-title'>{this.state.pageName}</h1>
                    <ContentBlock>
                        {this.state.renginiaList.map((renginys, index) => {
                            var hrefString = '/renginiai/' + renginys.ID;
                            return <Col key={index} xs={12} md={3} lg={3}>
                            <Link to={{pathname: hrefString }} className="link-light">
                                <Renginys Name={renginys.Name} Image={renginys.Files[0].Path} />
                            </Link>
                        </Col>
                        })
                    }
                    </ContentBlock>
                </Container>
                <Footer></Footer>
            </Container>
        );
    }
}

export default RenginiaiPage;